(()=>{const C={"schema_version":1,"shop":"driplore","origin":"https://driplore.com","clarity_project":"wp97ad4qr4","clarity_dispatchers":[{"version":"0.8.72","sha256":"23a46db20cec8327377ad6e97d43eaa708c2ad91def9a8176c1169c664b56477"},{"version":"0.8.73-beta","sha256":"eddba0ac4b393235d82a314eefafb93cda0548cd6722152b15c5ed4363a491bd"}],"clarity_tag":"driplore_session","bridge_event":"driplore_traffic_context_v1","cookie":"__Host-driplore_traffic_session","context_key":"driplore_traffic_context_v1","revocation_prefix":"driplore_traffic_revoked_v1:","grant_prefix":"driplore_traffic_grant_v1:","approved_campaigns":["","cgptads-gun-202610","cgptads-purchase-20mm-20261102-v1","cgptads-purchase-ak47s-20261102-v1","ig-bio-2026q2","tt-bio-2026q2"],"approved_contents":[""],"idle_ms":1800000,"session_max_ms":7200000,"revocation_ms":86400000,"retention_ms":864000000,"event_max_age_ms":86400000,"event_future_ms":300000,"max_storage_keys":512,"max_revocations":64,"event_namespace":"driplore:traffic:v1:","sources":["","instagram","tiktok","pinterest","facebook","chatgpt_ads","chatgpt.com","google","bing","yahoo","creator"],"media":["","organic_social","referral","paid","feed","social","organic"]};const S=(function createTrafficShared(C, cryptoApi = globalThis.crypto) {
  const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/;
  const digest = /^[a-f0-9]{64}$/;
  const numericId = /^[1-9][0-9]{0,19}$/;
  const fail = () => { throw new Error('invalid_traffic_data'); };
  const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
  const keys = (value, expected) => object(value) && Object.keys(value).sort().join('|') === [...expected].sort().join('|');
  const integer = value => Number.isSafeInteger(value) && value >= 0;

  function canonical(value) {
    if (Array.isArray(value)) return '[' + value.map(canonical).join(',') + ']';
    if (object(value)) return '{' + Object.keys(value).sort().map(k => JSON.stringify(k) + ':' + canonical(value[k])).join(',') + '}';
    return JSON.stringify(value);
  }

  async function hash(value) {
    const result = await cryptoApi.subtle.digest('SHA-256', new TextEncoder().encode(value));
    return Array.from(new Uint8Array(result), b => b.toString(16).padStart(2, '0')).join('');
  }

  function publicPath(value) {
    if (typeof value !== 'string' || value.length > 512 || value.includes('%')) return '';
    return /^\/(?:$|cart\/?|products\/[a-z0-9]+(?:-[a-z0-9]+)*\/?|collections\/[a-z0-9]+(?:-[a-z0-9]+)*\/?|pages\/[a-z0-9]+(?:-[a-z0-9]+)*\/?|blogs\/[a-z0-9]+(?:-[a-z0-9]+)*(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)?\/?)$/.test(value) ? value : '';
  }

  function validateUtm(value) {
    if (!keys(value, ['source', 'medium', 'campaign', 'content']) ||
      !C.sources.includes(value.source) || !C.media.includes(value.medium) ||
      typeof value.campaign !== 'string' || !C.approved_campaigns.includes(value.campaign) ||
      typeof value.content !== 'string' || !C.approved_contents.includes(value.content)) fail();
    return { source: value.source, medium: value.medium, campaign: value.campaign, content: value.content };
  }

  function utmFromUrl(url) {
    const value = { source: '', medium: '', campaign: '', content: '' };
    for (const key of Object.keys(value)) {
      const candidate = url.searchParams.get('utm_' + key) || '';
      if (key === 'source') value[key] = C.sources.includes(candidate) ? candidate : '';
      else if (key === 'medium') value[key] = C.media.includes(candidate) ? candidate : '';
      else if (key === 'campaign') value[key] = C.approved_campaigns.includes(candidate) ? candidate : '';
      else value[key] = C.approved_contents.includes(candidate) ? candidate : '';
    }
    return value;
  }

  function validateEvent(value, now) {
    const fields = ['schema_version', 'sid', 'page_id', 'event_id', 'timestamp_ms', 'type', 'page_kind', 'path', 'utm', 'product_id', 'variant_id'];
    if (!keys(value, fields) || value.schema_version !== C.schema_version ||
      typeof value.sid !== 'string' || !uuid.test(value.sid) ||
      typeof value.page_id !== 'string' || !uuid.test(value.page_id) ||
      typeof value.event_id !== 'string' || !digest.test(value.event_id) ||
      !integer(value.timestamp_ms) || !integer(now) ||
      value.timestamp_ms < now - C.event_max_age_ms || value.timestamp_ms > now + C.event_future_ms) fail();
    if (value.type === 'product_added_to_cart') {
      if (value.page_kind !== 'storefront' || !publicPath(value.path) ||
        typeof value.product_id !== 'string' || !numericId.test(value.product_id) ||
        typeof value.variant_id !== 'string' || !numericId.test(value.variant_id)) fail();
    } else if (value.type === 'checkout_started') {
      if (value.page_kind !== 'checkout' || value.path !== '' || value.product_id !== null || value.variant_id !== null) fail();
    } else fail();
    return {
      schema_version: C.schema_version, sid: value.sid, page_id: value.page_id,
      event_id: value.event_id, timestamp_ms: value.timestamp_ms, type: value.type,
      page_kind: value.page_kind, path: value.path, utm: validateUtm(value.utm),
      product_id: value.product_id, variant_id: value.variant_id,
    };
  }

  function validateContext(value, now, revocationDigest) {
    const fields = ['schema_version', 'sid', 'page_id', 'session_started_at', 'bridge_started_at', 'last_activity_at', 'expires_at', 'revocation_digest', 'path', 'utm'];
    if (!keys(value, fields) || value.schema_version !== C.schema_version ||
      !uuid.test(value.sid) || !uuid.test(value.page_id) || !digest.test(value.revocation_digest) ||
      value.revocation_digest !== revocationDigest || !publicPath(value.path)) fail();
    for (const field of ['session_started_at', 'bridge_started_at', 'last_activity_at', 'expires_at']) if (!integer(value[field])) fail();
    if (value.session_started_at > value.bridge_started_at || value.bridge_started_at > value.last_activity_at ||
      value.last_activity_at > now || now >= value.expires_at || now < value.bridge_started_at ||
      value.expires_at > value.last_activity_at + C.idle_ms ||
      value.expires_at > value.session_started_at + C.session_max_ms) fail();
    validateUtm(value.utm);
    return value;
  }

  function revocationSignature(entries, now) {
    if (entries.length > C.max_revocations) fail();
    const active = [];
    for (const [key, raw] of entries) {
      if (!key.startsWith(C.revocation_prefix) || !uuid.test(key.slice(C.revocation_prefix.length))) fail();
      let value;
      try { value = JSON.parse(raw); } catch { fail(); }
      if (!keys(value, ['schema_version', 'created_at', 'expires_at']) || value.schema_version !== C.schema_version ||
        !integer(value.created_at) || !integer(value.expires_at) || value.created_at > now ||
        value.expires_at !== value.created_at + C.revocation_ms) fail();
      if (value.expires_at > now) active.push([key, raw]);
    }
    return canonical(active.sort((a, b) => a[0].localeCompare(b[0])));
  }

  function grantSignature(entries, now) {
    if (entries.length > C.max_revocations) fail();
    const active = [];
    for (const [key, raw] of entries) {
      if (!key.startsWith(C.grant_prefix) || !uuid.test(key.slice(C.grant_prefix.length))) fail();
      let value;
      try { value = JSON.parse(raw); } catch { fail(); }
      if (!keys(value, ['schema_version', 'created_at', 'expires_at', 'revocation_digest']) || value.schema_version !== C.schema_version ||
        !integer(value.created_at) || !integer(value.expires_at) || value.created_at > now || !digest.test(value.revocation_digest) ||
        value.expires_at !== value.created_at + C.revocation_ms) fail();
      if (value.expires_at > now) active.push([key, raw]);
    }
    return canonical(active.sort((a, b) => a[0].localeCompare(b[0])));
  }

  function grantsAuthorize(entries, now, ledger) {
    const active = JSON.parse(grantSignature(entries, now));
    return active.some(([, raw]) => {
      const value = JSON.parse(raw);
      return value.revocation_digest === ledger.digest && value.created_at > ledger.latest_at;
    });
  }

  async function entries(storage, prefix = C.revocation_prefix) {
    const count = await storage.length();
    if (!integer(count) || count > C.max_storage_keys) fail();
    const result = [];
    const seen = new Set();
    for (let i = 0; i < count; i++) {
      const key = await storage.key(i);
      if (typeof key !== 'string' || seen.has(key)) fail();
      seen.add(key);
      if (key.startsWith(prefix)) {
        const value = await storage.getItem(key);
        if (typeof value !== 'string') fail();
        result.push([key, value]);
      }
    }
    if (await storage.length() !== count) fail();
    return result.sort((a, b) => a[0].localeCompare(b[0]));
  }

  async function snapshotLedger(storage, now) {
    const first = await entries(storage);
    const second = await entries(storage);
    if (canonical(first) !== canonical(second)) fail();
    const signature = revocationSignature(first, now);
    const result = await hash(signature);
    const third = await entries(storage);
    if (canonical(first) !== canonical(third)) fail();
    const active = JSON.parse(signature);
    const latestAt = active.reduce((latest, [, raw]) => Math.max(latest, JSON.parse(raw).created_at), 0);
    return { signature, digest: result, entries: first, latest_at: latestAt };
  }

  async function hasGrant(storage, now, ledger, required = ledger.signature !== '[]') {
    if (!required) return true;
    const first = await entries(storage, C.grant_prefix);
    const second = await entries(storage, C.grant_prefix);
    if (canonical(first) !== canonical(second)) fail();
    return grantsAuthorize(first, now, ledger);
  }

  async function appendRevocation(storage, now) {
    const key = C.revocation_prefix + cryptoApi.randomUUID();
    await storage.setItem(key, canonical({ schema_version: C.schema_version, created_at: now, expires_at: now + C.revocation_ms }));
    return key;
  }

  return {
    canonical, hash, publicPath, validateUtm, utmFromUrl, validateEvent, validateContext,
    revocationSignature, grantSignature, grantsAuthorize, snapshotLedger, appendRevocation, hasGrant,
    isUuid: value => typeof value === 'string' && uuid.test(value),
    isDigest: value => typeof value === 'string' && digest.test(value),
    numericId: value => typeof value === 'string' && numericId.test(value),
  };
})(C);const script=document.currentScript;const controller=(function startTrafficTheme(w, C, S, mode = 'disabled') {
  const d = w.document;
  const status = { state: 'disabled', reason: 'not_enabled' };
  const storage = () => ({
    length: () => w.localStorage.length,
    key: i => w.localStorage.key(i),
    getItem: k => w.localStorage.getItem(k),
    setItem: (k, v) => w.localStorage.setItem(k, v),
  });
  let generation = 0;
  let serial = Promise.resolve();
  let active = null;
  let taggedSid = null;
  let forceSid = false;
  let lastWall = w.Date.now();
  let lastPersisted = 0;
  let attempts = 0;
  let timer = null;
  let disposed = false;
  let previouslyAllowed = false;
  let lastConsentAllowed = consentState();
  let grantGeneration = null;
  let grantAt = 0;
  const documentStartedAt = Math.floor(w.performance?.timeOrigin);
  let revocationObserved = w.Date.now() - documentStartedAt >= C.revocation_ms;
  const hashes = new WeakMap();
  const listeners = [];
  const clock = () => w.Date.now();
  function consentState() {
    try {
      const api = w.Shopify?.customerPrivacy;
      if (!api) return null;
      const values = [api.analyticsProcessingAllowed(), api.marketingAllowed(), api.saleOfDataAllowed()];
      if (values.some(value => typeof value !== 'boolean')) return null;
      return values.every(value => value === true);
    } catch { return null; }
  }
  const allowed = () => consentState() === true;
  const visible = () => d.visibilityState === 'visible';
  const notify = value => w.Shopify?.analytics?.publish(C.bridge_event, value);
  const setStatus = (state, reason) => { status.state = state; status.reason = reason; };

  function clearContext() {
    active = null;
    try { w.sessionStorage.removeItem(C.context_key); } catch {}
    try { notify({ invalidate: true }); } catch {}
  }

  function fail(reason) {
    generation += 1;
    clearContext();
    setStatus('unavailable', reason);
  }

  function current(ticket) {
    return !disposed && visible() && allowed() && ticket === generation;
  }

  function signatureNow(now) {
    const store = w.localStorage;
    if (store.length > C.max_storage_keys) throw new Error('storage_capacity');
    const entries = [];
    for (let i = 0; i < store.length; i++) {
      const key = store.key(i);
      if (typeof key !== 'string') throw new Error('storage_changed');
      if (key.startsWith(C.revocation_prefix)) entries.push([key, store.getItem(key)]);
    }
    return S.revocationSignature(entries, now);
  }

  function grantsNow(now, ledger) {
    const store = w.localStorage;
    if (store.length > C.max_storage_keys) throw new Error('storage_capacity');
    const entries = [];
    for (let i = 0; i < store.length; i++) {
      const key = store.key(i);
      if (typeof key !== 'string') throw new Error('storage_changed');
      if (key.startsWith(C.grant_prefix)) entries.push([key, store.getItem(key)]);
    }
    return S.grantsAuthorize(entries, now, ledger);
  }

  function cleanupLedger(now) {
    const store = w.localStorage;
    if (store.length > C.max_storage_keys) throw new Error('storage_capacity');
    const expired = [];
    for (let i = 0; i < store.length; i++) {
      const key = store.key(i);
      if (typeof key !== 'string') throw new Error('storage_changed');
      if (key.startsWith(C.revocation_prefix) && S.revocationSignature([[key, store.getItem(key)]], now) === '[]') expired.push(key);
      if (key.startsWith(C.grant_prefix) && S.grantSignature([[key, store.getItem(key)]], now) === '[]') expired.push(key);
    }
    for (const key of expired) store.removeItem(key);
  }

  function revoke(observedConsent) {
    generation += 1;
    previouslyAllowed = false;
    lastConsentAllowed = observedConsent;
    grantGeneration = null;
    if (observedConsent === false) revocationObserved = true;
    forceSid = true;
    taggedSid = null;
    clearContext();
    try {
      d.cookie = C.cookie + '=; Path=/; Max-Age=0; Secure; SameSite=Lax';
      if (observedConsent === false) {
        const now = clock();
        w.localStorage.setItem(C.revocation_prefix + w.crypto.randomUUID(), S.canonical({
          schema_version: C.schema_version, created_at: now, expires_at: now + C.revocation_ms,
        }));
        setStatus('disabled', 'privacy_denied');
      } else setStatus('unavailable', 'privacy_unavailable');
    } catch { setStatus('unavailable', 'privacy_storage_failed'); }
  }

  function cookieSession(now, revocationDigest) {
    if (!forceSid) {
      const pair = d.cookie.split(';').map(x => x.trim()).find(x => x.startsWith(C.cookie + '='));
      if (pair) {
        try {
          const v = JSON.parse(decodeURIComponent(pair.slice(C.cookie.length + 1)));
          if (S.isUuid(v.sid) && v.revocation_digest === revocationDigest &&
            Number.isSafeInteger(v.session_started_at) && Number.isSafeInteger(v.last_activity_at) &&
            v.session_started_at <= v.last_activity_at && v.last_activity_at <= now &&
            now - v.last_activity_at < C.idle_ms && now - v.session_started_at < C.session_max_ms) return v;
        } catch {}
      }
    }
    return { sid: w.crypto.randomUUID(), session_started_at: now, last_activity_at: now, revocation_digest: revocationDigest };
  }

  async function dispatcher(ticket) {
    const fn = w.clarity;
    if (typeof fn !== 'function' || Object.hasOwn(fn, 'q')) return null;
    const expected = C.clarity_dispatchers.find(entry => entry.version === fn.v);
    if (!expected) return null;
    if (!hashes.has(fn)) hashes.set(fn, S.hash(Function.prototype.toString.call(fn)));
    const hash = await hashes.get(fn);
    return current(ticket) && w.clarity === fn && fn.v === expected.version && hash === expected.sha256 ? fn : null;
  }

  async function update(ticket) {
    if (!current(ticket)) return;
    const now = clock();
    if (!Number.isFinite(documentStartedAt) || now < lastWall || now < documentStartedAt) { fail('clock_unavailable_or_reversed'); return; }
    if (now - lastWall >= C.revocation_ms) revocationObserved = true;
    lastWall = now;
    cleanupLedger(now);
    const ledger = await S.snapshotLedger(storage(), now);
    if (ledger.signature !== '[]') revocationObserved = true;
    if (!current(ticket)) return;
    const fn = await dispatcher(ticket);
    if (!current(ticket)) return;
    if (!fn) {
      clearContext();
      setStatus('unavailable', 'dispatcher_unverified');
      if (attempts++ < 20 && timer === null) {
        timer = w.setTimeout(() => { timer = null; enqueue(); }, 500);
      }
      return;
    }
    const grantHere = grantGeneration === ticket && grantAt > ledger.latest_at && clock() - grantAt < C.revocation_ms;
    if (revocationObserved && !grantHere && !grantsNow(clock(), ledger)) {
      clearContext();
      setStatus('disabled', 'reauthorization_required');
      return;
    }
    const committedAt = clock();
    if (committedAt < now) { fail('clock_reversed'); return; }
    if (active && (active.revocation_digest !== ledger.digest || committedAt >= active.expires_at)) {
      forceSid = true;
      clearContext();
    }
    const session = active || cookieSession(committedAt, ledger.digest);
    const context = {
      schema_version: C.schema_version, sid: session.sid,
      page_id: active?.page_id || w.crypto.randomUUID(),
      session_started_at: session.session_started_at,
      bridge_started_at: active?.bridge_started_at || committedAt,
      last_activity_at: committedAt,
      expires_at: Math.min(committedAt + C.idle_ms, session.session_started_at + C.session_max_ms),
      revocation_digest: ledger.digest, path: S.publicPath(w.location.pathname),
      utm: active?.utm || S.utmFromUrl(new URL(w.location.href)),
    };
    S.validateContext(context, committedAt, ledger.digest);
    if (!current(ticket) || w.clarity !== fn || signatureNow(clock()) !== ledger.signature) return;
    if (grantHere) {
      w.localStorage.setItem(C.grant_prefix + w.crypto.randomUUID(), S.canonical({
        schema_version: C.schema_version, created_at: grantAt, expires_at: grantAt + C.revocation_ms,
        revocation_digest: ledger.digest,
      }));
      grantGeneration = null;
    }
    if (revocationObserved && !grantsNow(clock(), ledger)) {
      clearContext();
      setStatus('disabled', 'reauthorization_required');
      return;
    }
    if ((revocationObserved && !grantsNow(clock(), ledger)) || signatureNow(clock()) !== ledger.signature ||
      !current(ticket) || w.clarity !== fn) {
      clearContext();
      return;
    }
    if (taggedSid !== context.sid) {
      fn('set', C.clarity_tag, context.sid);
      taggedSid = context.sid;
    }
    if ((revocationObserved && !grantsNow(clock(), ledger)) || signatureNow(clock()) !== ledger.signature ||
      !current(ticket) || w.clarity !== fn) {
      clearContext();
      return;
    }
    d.cookie = C.cookie + '=' + encodeURIComponent(S.canonical({
      sid: context.sid, session_started_at: context.session_started_at,
      last_activity_at: committedAt, revocation_digest: ledger.digest,
    })) + '; Path=/; Max-Age=' + Math.max(1, Math.floor((context.expires_at - committedAt) / 1000)) + '; Secure; SameSite=Lax';
    if (!d.cookie.split(';').some(x => x.trim().startsWith(C.cookie + '='))) throw new Error('cookie_unavailable');
    w.sessionStorage.setItem(C.context_key, S.canonical(context));
    if (!current(ticket) || signatureNow(clock()) !== ledger.signature) { clearContext(); return; }
    active = context;
    forceSid = false;
    lastPersisted = committedAt;
    notify(context);
    setStatus('ready', 'context_published');
  }

  function enqueue() {
    const ticket = generation;
    serial = serial.then(() => update(ticket)).catch(() => fail('storage_or_context_failed'));
    return serial;
  }

  function refresh(explicitGrant = false) {
    generation += 1;
    clearContext();
    attempts = 0;
    const observedConsent = consentState();
    lastConsentAllowed = observedConsent;
    if (observedConsent !== true) { revoke(observedConsent); return; }
    if (explicitGrant === true) {
      grantGeneration = generation;
      grantAt = clock();
      forceSid = true;
    }
    if (!previouslyAllowed) forceSid = true;
    previouslyAllowed = true;
    enqueue();
  }

  function listen(target, name, fn, options) {
    target.addEventListener(name, fn, options);
    listeners.push(() => target.removeEventListener(name, fn, options));
  }

  const controller = {
    status,
    idle: () => serial,
    dispose: () => {
      disposed = true;
      generation += 1;
      if (timer !== null) w.clearTimeout(timer);
      for (const remove of listeners) remove();
      clearContext();
    },
  };
  if (!['validate', 'events'].includes(mode) || w.location.origin !== C.origin ||
    w.Shopify?.designMode || (mode === 'events' && new URL(w.location.href).searchParams.has('preview_theme_id'))) return controller;
  clearContext();
  listen(d, 'visitorConsentCollected', () => {
    const currentAllowed = consentState();
    const explicitGrant = currentAllowed === true && lastConsentAllowed === false;
    lastConsentAllowed = currentAllowed;
    refresh(explicitGrant);
  });
  listen(d, 'visibilitychange', () => {
    generation += 1;
    clearContext();
    if (visible()) refresh();
  });
  listen(w, 'pagehide', () => { generation += 1; clearContext(); });
  listen(w, 'pageshow', refresh);
  listen(w, 'storage', event => {
    if (event.key === null || event.key.startsWith(C.revocation_prefix) || event.key.startsWith(C.grant_prefix)) {
      if (event.key === null || event.key.startsWith(C.revocation_prefix)) revocationObserved = true;
      generation += 1;
      forceSid = true;
      clearContext();
      if (visible() && allowed()) enqueue();
    }
  });
  const activity = event => {
    if (!event.isTrusted || !visible()) return;
    const observedConsent = consentState();
    lastConsentAllowed = observedConsent;
    if (observedConsent !== true) { revoke(observedConsent); return; }
    if (clock() - lastPersisted >= 5000) enqueue();
  };
  for (const type of ['pointerdown', 'keydown', 'touchstart', 'scroll']) listen(d, type, activity, { passive: true, capture: true });
  try {
    if (w.Shopify?.customerPrivacy) {
      refresh();
    } else if (typeof w.Shopify?.loadFeatures === 'function') {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (disposed) return;
        if (error || !w.Shopify.customerPrivacy) { fail('privacy_unavailable'); return; }
        refresh();
      });
    } else fail('privacy_unavailable');
  } catch { fail('privacy_unavailable'); }
  return controller;
})(window,C,S,script?.dataset.trafficMode||'disabled');window.__driploreTrafficStatus=controller.status;})();
